import { differenceInYears } from "date-fns";

export function isAdult(date) {
  const [day, month, year] = typeof date === "string" ? date.split("/") : date;

  const dif = differenceInYears(new Date(), new Date(year, month - 1, day));

  return dif >= 18;
}
